:host {
  display: block;
  max-width: 46.875rem;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: var(--cms-components-mb);
  position: relative;
  cursor: pointer;
}

.youtube-container {
  padding: 0 var(--cms-spacing-100);
}
